<script setup>
import { computed, nextTick, ref } from "vue";
import ContactPanel from 'dashboard/routes/dashboard/conversation/ContactPanel.vue';
import TabBar from 'dashboard/components-next/tabbar/TabBar.vue';
import OrderView from 'dashboard/routes/dashboard/order/OrderView.vue';
import { useEmitter } from 'dashboard/composables/emitter';
import { emitter } from 'shared/helpers/mitt';
import { useI18n } from 'vue-i18n';

defineProps({
  currentChat: {
    required: true,
    type: Object,
  },
});

const emit = defineEmits(['toggleContactPanel']);

// const getters = useStoreGetters();

const { t } = useI18n();

const CONTACT_TABS_OPTIONS = [
  { key: 'Contact', value: 'contact' },
  { key: 'Order', value: 'order' },
];

const tabs = computed(() => {
  return CONTACT_TABS_OPTIONS.map(tab => ({
    label: tab.key,
    value: tab.value,
  }));
});
const activeTab = ref(0);
const toggleContactPanel = () => {
  emit('toggleContactPanel');
};

const handleTabChange = selectedTab => {
  activeTab.value = tabs.value.findIndex(
    tabItem => tabItem.value === selectedTab.value
  );
};

const showOrderTab = computed(() => {
  return true;
});

useEmitter('createGiftCardOrder', message => {
  activeTab.value = 1;
  nextTick(() => {
    emitter.emit('messageForOrder', message);
  });
});
useEmitter('showGiftCardWithdraw', message => {
  activeTab.value = 1;
  nextTick(() => {
    emitter.emit('createGiftCardWithdraw', message);
  });
});
</script>

<template>
  <div
    class="ltr:border-l rtl:border-r border-n-weak h-full overflow-hidden z-10 min-w-[300px] w-[300px] 2xl:min-w-96 2xl:w-96 flex flex-col bg-n-background"
  >
    <div v-if="showOrderTab" class="p-2">
      <TabBar
        :tabs="tabs"
        :initial-active-tab="activeTab"
        class="w-full [&>button]:w-full"
        @tab-changed="handleTabChange"
      />
    </div>
    <div class="overflow-auto flex flex-1">
      <ContactPanel
        v-if="!activeTab"
        :conversation-id="currentChat.id"
        :inbox-id="currentChat.inbox_id"
        :on-toggle="toggleContactPanel"
      />
      <OrderView
        v-else-if="activeTab === 1 && showOrderTab"
        :conversation-id="currentChat.id"
        :inbox-id="currentChat.inbox_id"
      />
    </div>
  </div>
</template>
